export const DATE_VIEW_FORMAT = "DD.MM.YYYY";
export const DATE_TIME_VIEW_FORMAT = "DD.MM.YYYY HH:mm";